import { MD5Algo } from 'crypto-es/lib/md5.js'

const userAgent = window.navigator.userAgent
let seq = Math.floor(Math.random() * Math.floor(4294967295))
const md5Sum = MD5Algo.create().update(userAgent).finalize()

function createTraceID() {
  const traceID = new Uint8Array(16)

  traceID.set(md5Sum.words.slice(0, 4), 0) // Copy first 4 bytes of md5Sum to traceID

  const now = BigInt(Date.now()) * BigInt(1000000) // Convert current time to nanoseconds
  const timeBuffer = new ArrayBuffer(8)
  const dataView = new DataView(timeBuffer)
  dataView.setBigUint64(0, now)
  traceID.set(new Uint8Array(timeBuffer), 4) // Set next 8 bytes of traceID with current time

  // Set last 4 bytes with sequence number
  traceID.set(new Uint8Array(new Uint32Array([seq++]).buffer), 12)

  const str = traceID.reduce((acc, byte) => acc + byte.toString(16).padStart(2, '0'), '')

  return str
}

export { createTraceID }
